const guiColors = {
    'motion-primary': 'hsla(350, 100%, 70%, 1)',
    'motion-primary-transparent': 'hsla(350, 100%, 70%, 0.9)',
    'motion-tertiary': 'hsla(350, 100%, 60%, 1)',

    'looks-secondary': 'hsla(350, 100%, 70%, 1)',
    'looks-transparent': 'hsla(350, 100%, 70%, 0.35)',
    'looks-light-transparent': 'hsla(350, 100%, 70%, 0.15)',
    'looks-secondary-dark': 'hsla(350, 100%, 60%, 1)',

    'extensions-primary': 'hsla(0, 85%, 70%, 1)',
    'extensions-tertiary': 'hsla(0, 85%, 45%, 1)',
    'extensions-transparent': 'hsla(0, 85%, 70%, 0.35)',
    'extensions-light': 'hsla(0, 57%, 90%, 1)',

    'drop-highlight': 'hsl(350, 100%, 83%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(350, 100%, 70%)',
    checkboxActiveBorder: 'hsl(350, 100%, 60%)'
};

export {
    guiColors,
    blockColors
};